import React from 'react';
import SVGLoader from './SVGLoader';

const CopyIcon = props => {
  const { width, height, viewboxWidth, viewboxHeight } = props;

  return (
    <SVGLoader
      {...props}
      width={width || 12}
      height={height || 12}
      viewboxWidth={viewboxWidth || 140}
      viewboxHeight={viewboxHeight || 140}
    >
      <g fillRule="nonzero">
        <path d="M10.882.882h85c5.523 0 10 4.477 10 10v85c0 5.523-4.477 10-10 10h-85c-5.523 0-10-4.477-10-10v-85c0-5.523 4.477-10 10-10z" />
        <path d="M130.368 31.71a8.736 8.736 0 00-8.736 8.75v75.908a5.278 5.278 0 01-5.264 5.264H40.46a8.75 8.75 0 100 17.5h75.908c12.563-.023 22.74-10.201 22.764-22.764V40.46a8.75 8.75 0 00-8.764-8.75z" />
      </g>
    </SVGLoader>
  );
};

export default CopyIcon;
